import { useEffect, useRef, useState } from "react";
import { GiMagnifyingGlass, GiNotebook, GiWeightLiftingUp, GiChart, GiLaurelsTrophy } from "react-icons/gi";
import SectionHeading from "../common/SectionHeading";
import "./TrainingExperience.css";


const STEPS = [
  {
    n: "01",
    icon: GiMagnifyingGlass,
    title: "Assess",
    desc: "We start with a movement screen and goal conversation so your plan starts from where you actually are.",
    image: "/gymimages/ASSESS.png",
    alt: "Fitness assessment and movement screening session"
  },
  {
    n: "02",
    icon: GiNotebook,
    title: "Plan",
    desc: "Your coach builds a structured program around your assessment, schedule and target outcome.",
    image: "/gymimages/plan.png",
    alt: "Personalized workout plan and training program"
  },
  {
    n: "03",
    icon: GiWeightLiftingUp,
    title: "Train",
    desc: "Coached sessions with real-time form correction — every rep counts toward the plan.",
    image: "/gymimages/train.png",
    alt: "/gymimages/train.png"
  },
  {
    n: "04",
    icon: GiChart,
    title: "Track",
    desc: "Progress is logged and reviewed regularly so the plan adapts as you get stronger.",
    image: "/gymimages/track.png",
    alt: "/gymimages/track.png"
  },
  {
    n: "05",
    icon: GiLaurelsTrophy,
    title: "Transform",
    desc: "Consistent training plus tracked progress compounds into results you can see and measure.",
    image: "/gymimages/gym10.jpg",
    alt: "Transformation results showing progress and achievements"
  },
];

export default function TrainingExperience() {
  const [active, setActive] = useState(0);
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.index);
            setActive(idx);
          }
        });
      },
      { threshold: 0.6, rootMargin: "-20% 0px -20% 0px" }
    );
    refs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="training-exp section">
      <div className="container">
        <SectionHeading eyebrow="The Process" title="Your training" highlight="experience" />
        <div className="training-exp__grid">
          <div className="training-exp__sticky">
            <img
              src={STEPS[active].image}
              alt={STEPS[active].alt}
              className="training-exp__image"
              style={{ width: '100%', height: 'auto', aspectRatio: '4/5', objectFit: 'cover' }}
            />
            <div className="training-exp__sticky-label">
              <span>{STEPS[active].n}</span> {STEPS[active].title}
            </div>
          </div>
          <div className="training-exp__list">
            {STEPS.map((step, i) => {
              const Icon = step.icon;
              return (
                <div
                  key={step.n}
                  ref={(el) => (refs.current[i] = el)}
                  data-index={i}
                  className={`training-exp__item ${active === i ? "training-exp__item--active" : ""}`}
                >
                  <div className="training-exp__item-head">
                    <Icon aria-hidden="true" />
                    <span className="training-exp__item-num">{step.n}</span>
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
